
import React from "react";
import { Clock, Mic, Users, BarChart2 } from "lucide-react";

interface TileProps {
  icon: React.ReactNode;
  title: string;
  value: string | number;
  description?: string;
  trend?: {
    value: string;
    positive?: boolean;
  };
  bgColorClass?: string;
}

const Tile: React.FC<TileProps> = ({
  icon,
  title,
  value,
  description,
  trend,
  bgColorClass = "bg-card"
}) => {
  return (
    <div className={`${bgColorClass} rounded-xl shadow-sm border border-border/30 p-6 transition-all hover:shadow-elevated`}>
      <div className="flex justify-between items-start mb-4">
        <div className="text-metsci-red/70 p-2 rounded-lg bg-primary/5">{icon}</div>
        {trend && (
          <div className={`text-xs font-medium px-2.5 py-1 rounded-full ${trend.positive ? 'bg-status-scheduled/10 text-status-scheduled' : 'bg-status-pending/10 text-status-pending'}`}>
            {trend.value}
          </div>
        )}
      </div>
      <div className="space-y-2">
        <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
        <p className="text-2xl font-bold text-foreground">{value}</p>
        {description && (
          <p className="text-xs text-muted-foreground mt-1">{description}</p>
        )}
      </div>
    </div>
  );
};

const DashboardTiles = () => {
  return (
    <>
      <Tile 
        icon={<Mic className="w-6 h-6" />}
        title="Active Episodes"
        value="12"
        description="Episodes in production"
      />
      <Tile 
        icon={<Users className="w-6 h-6" />}
        title="Pending Guests"
        value="8"
        description="Awaiting confirmation"
      />
      <Tile 
        icon={<Clock className="w-6 h-6" />}
        title="Recording Hours"
        value="24.5"
        description="This month"
        trend={{
          value: "+12%",
          positive: true
        }}
      />
      <Tile 
        icon={<BarChart2 className="w-6 h-6" />}
        title="Total Listens"
        value="156.2K"
        description="From all episodes"
        trend={{
          value: "+8%",
          positive: true
        }}
      />
    </>
  );
};

export default DashboardTiles;
